import { applyMiddleware, createStore, compose } from "redux";
import { reducers } from "./reducers";
import { lotsMdl } from "./middleware/lot";
import { pickupFormMdl } from "./middleware/pickupForm";
import { apiMdl } from "./middleware/api";
import { stepperMdl } from "./middleware/stepper";
import { addressMdl } from "./middleware/address";
import { throttleMdl } from "./middleware/throttle";
import { errosMdl } from "./middleware/errors";


// dev tool
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  reducers,
  composeEnhancers(
    applyMiddleware(
      throttleMdl,
      ...lotsMdl,
      ...pickupFormMdl,
      ...addressMdl,
      ...errosMdl,
      stepperMdl,
      apiMdl
    )
  )
);



// WEBPACK FOOTER //
// ./src/redux/store.js